import { UIState } from './store';

export function initOhlecHUD() {
  console.log('[OHLEC HUD] Initializing...');

  // Initially, Step 0 (Initialization) automatically transitions to Step 1
  // We can update the UI wizard state
  setStep(1);

  // Tension/Compression Visualization Controls
  const showTensionCb = document.getElementById('dbg-showTension') as HTMLInputElement;
  const tensionGlobalRadio = document.getElementById('tension-global') as HTMLInputElement;
  const tensionLogRadio = document.getElementById('tension-log') as HTMLInputElement;

  showTensionCb?.addEventListener('change', () => {
    UIState.updateFeature('showTension', showTensionCb.checked);
  });

  tensionGlobalRadio?.addEventListener('change', () => {
    if (tensionGlobalRadio.checked) UIState.updateFeature('globalTension', true);
  });

  tensionLogRadio?.addEventListener('change', () => {
    if (tensionLogRadio.checked) UIState.updateFeature('globalTension', false);
  });

  UIState.subscribe((state) => {
    if (showTensionCb) {
      showTensionCb.checked = !!state.featureFlags.showTension;
    }
    const tensionModeContainer = document.getElementById('tension-mode-container');
    if (tensionModeContainer) {
      tensionModeContainer.style.display = state.featureFlags.showTension ? 'flex' : 'none';
    }
    if (tensionGlobalRadio) tensionGlobalRadio.checked = state.featureFlags.globalTension;
    if (tensionLogRadio) tensionLogRadio.checked = !state.featureFlags.globalTension;
  });
}

export function setStep(stepNumber: number) {
  // Reset all steps to inactive/dimmed
  for (let i = 0; i < 5; i++) {
    const stepEl = document.getElementById(`step-${i}`);
    if (stepEl) {
      stepEl.style.opacity = '0.5';
      stepEl.style.background = 'transparent';
      stepEl.style.borderLeft = '3px solid transparent';
    }
  }

  // Highlight the active step
  const activeStep = document.getElementById(`step-${stepNumber - 1}`);
  if (activeStep) {
    activeStep.style.opacity = '1';
    activeStep.style.background = 'rgba(0,255,255,0.1)';
    activeStep.style.borderLeft = '3px solid var(--accent-cyan)';
  }

  // Update contextual text
  const title = document.getElementById('ohlec-action-title');
  const desc = document.getElementById('ohlec-action-desc');
  
  if (!title || !desc) return;

  switch(stepNumber) {
    case 1:
      title.innerText = 'Step 1: Define Objective';
      desc.innerText = 'Identify the safest drop zone for the log segment. Click the ground to place your target zone.';
      break;
    case 2:
      title.innerText = 'Step 2: Hazards Scan';
      desc.innerText = 'Orbit the camera and click to identify all critical hazards (widowmakers, spring poles, etc).';
      break;
    case 3:
      title.innerText = 'Step 3: Leans & Binds';
      desc.innerText = 'Toggle Stress Vision to see internal forces, then classify the bind type.';
      break;
    case 4:
      title.innerText = 'Step 4: Escape Route';
      desc.innerText = 'Draw your intended escape path in the safe 45-degree quadrant.';
      break;
    case 5:
      title.innerText = 'Step 5: Cut Plan';
      desc.innerText = 'Place your virtual cut planes to safely relieve binds without pinching the bar.';
      break;
  }
}

export function updateObjectiveUI(currentIndex: number, totalCount: number, description: string) {
  const title = document.getElementById('ohlec-action-title');
  const desc = document.getElementById('ohlec-action-desc');

  if (title) {
    if (totalCount > 1) {
      title.innerText = `Step 1: Define Objective (${currentIndex}/${totalCount})`;
    } else {
      title.innerText = 'Step 1: Define Objective';
    }
  }

  if (desc) {
    desc.innerText = `${description} Click the ground to mark the zone.`;
  }
}

export function updateLeanUI(currentIndex: number, totalCount: number, bindType: string) {
  const title = document.getElementById('ohlec-action-title');
  const desc = document.getElementById('ohlec-action-desc');

  if (title) {
    title.innerText = `Step 3: Leans & Binds (${currentIndex}/${totalCount})`;
  }

  if (desc) {
    const formattedBind = bindType.replace(/_/g, ' ').toUpperCase();
    desc.innerText = `Click the log affected by ${formattedBind}. Toggle Stress Vision if needed to inspect forces.`;
  }
}

export function showOhlecToast(message: string, isSuccess: boolean) {
  let toast = document.getElementById('ohlec-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'ohlec-toast';
    toast.style.position = 'fixed';
    toast.style.top = '2rem';
    toast.style.left = '50%';
    toast.style.transform = 'translateX(-50%)';
    toast.style.padding = '0.75rem 1.5rem';
    toast.style.borderRadius = '8px';
    toast.style.fontSize = '1rem';
    toast.style.fontWeight = '600';
    toast.style.zIndex = '9999';
    toast.style.pointerEvents = 'none';
    toast.style.backdropFilter = 'blur(10px)';
    toast.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
    document.body.appendChild(toast);
  }

  toast.style.background = isSuccess
    ? 'rgba(0, 255, 136, 0.2)'
    : 'rgba(255, 68, 68, 0.2)';
  toast.style.border = isSuccess
    ? '1px solid var(--accent-cyan, #00ff88)'
    : '1px solid #ff4444';
  toast.style.color = isSuccess ? '#00ff88' : '#ff6666';
  toast.innerText = message;
  toast.style.opacity = '1';
  toast.style.transform = 'translateX(-50%) translateY(0)';

  if ((toast as any)._timeout) {
    clearTimeout((toast as any)._timeout);
  }

  (toast as any)._timeout = setTimeout(() => {
    if (toast) {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-50%) translateY(-10px)';
    }
  }, 2500);
}
